export * from "./Contracts";
export * from "./Discounts";
export * from "./EApportionmentType";
export * from "./EAttachmentType";
export * from "./EAttachmentUploadStatus";
export * from "./EDashboardSortFields";
export * from "./EImportDestination";
export * from "./EManagmentType";
export * from "./EProcessName";
export * from "./ERowMovementTypes";
export * from "./Measurements";

/** Enumerador com os estados do menu lateral esquerdo na tela de Contrato.
 * @category Contracts
 */
export const enum ELeftSideMenu {
  CLOSED = "",
  ADDS_AND_CANCELS = "adds",
  LINE_HISTORY = "history",
  READJUSTMENT = "readjustment",
}

export const enum EContractTab {
  INDICATOR = 0,
  MEASUREMENT = 1,
  CONTRACT = 2,
}
